import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOutlinedPinOffIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 3L21 21M15 4.5L11.751 7.749M9.181 9.182L7 10L5.5 11.5L12.5 18.5L14 17L14.82 14.814M16.25 12.251L19.5 9M9 15L4.5 19.5M14.5 4L20 9.5", stroke: "#333333", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgOutlinedPinOffIcon);
const Memo = memo(ForwardRef);
export default Memo;
